import Swiper from 'swiper';
import {Pagination, Autoplay, Controller, EffectFade, Navigation} from 'swiper/modules';
import {debounce} from 'lodash';

const SLIDER_SELECTOR = '.js-slider';
const DESKTOP_BP = 1024;

const createSliderText = (parent, effect) => {
	const sliderEl = parent.querySelector('.js-slider-text');
	return new Swiper(sliderEl, {
		modules: [Pagination, Controller, EffectFade, Navigation],
		effect,
		speed: 1000,
		pagination: {
			el: parent.querySelector('.js-slider-pagination'),
			clickable: true,
			renderBullet: function(index, className) {
				return '<button class="' + className + '"></button>';
			},
		},
		navigation: {
			nextEl: parent.querySelector('.js-slider-next'),
			prevEl: parent.querySelector('.js-slider-prev'),
		},
		breakpoints: {
			0: {
				allowTouchMove: true,
				spaceBetween: 16
			},
			1024: {
				desktop: true,
				allowTouchMove: false,
			},
		},
	});
};

const createTextboxSlider = (sliderEl) => {
	let sliderText;
	let isMobile = window.innerWidth < DESKTOP_BP;
	let animationType = null;
	const parent = sliderEl.closest('.js-textbox-media');
	const slider = new Swiper(sliderEl, {
		modules: [Pagination, Controller],
		speed: 1000,
		breakpoints: {
			0: {
				spaceBetween: 16
			}
		},
	});

	const initSliderText = () => {
		if (window.innerWidth < DESKTOP_BP && isMobile && animationType === 'slide') return;
		if (sliderText) {
			sliderText.destroy(true, true);
		}
		animationType = window.innerWidth < DESKTOP_BP ? 'slide' : 'fade';
		sliderText = createSliderText(parent, animationType);
		slider.slideTo(0, 0);
		sliderText.controller.control = slider;
		slider.controller.control = sliderText;
	};
	initSliderText();
	const debouncedInit = debounce(initSliderText, 300);
	window.addEventListener('resize', debouncedInit);
	isMobile = window.innerWidth < DESKTOP_BP;

	return slider;
};

const createCommonSlider = (sliderEl) => {
	const autoplayDelay = sliderEl.dataset.autoplayDelay;
	const isFade = sliderEl.dataset.animationType === 'fade';
	const slideCount = sliderEl.querySelectorAll('.swiper-slide').length;
	const sliderScope = sliderEl.closest('.js-slider-container') || sliderEl.parentElement;
	const swiper =  new Swiper(sliderEl, {
		modules: isFade ? [Pagination, Autoplay, Navigation, EffectFade] : [Pagination, Autoplay, Navigation],
		...(isFade && {effect: 'fade', fadeEffect: {crossFade: true}}),
		// Fade effect throws when loop is enabled with too few slides to loop
		loop: isFade ? slideCount > 1 : true,
		speed: 700,
		grabCursor: true,
		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},
		autoplay: autoplayDelay ? {
			delay: autoplayDelay,
			pauseOnMouseEnter: false,
			disableOnInteraction: false,
		} : false,
		pagination: {
			el: sliderScope.querySelector('.js-slider-pagination'),
			clickable: true,
			renderBullet: function(index, className) {
				return '<button class="' + className + '"></button>';
			},
		},
		navigation: {
			nextEl: sliderScope.querySelector('.js-slider-next'),
			prevEl: sliderScope.querySelector('.js-slider-prev'),
		},
		on: {
			init: (swiper) => {
				if ( swiper.slides.length < 2 ) {
					swiper.allowTouchMove = false;
				}
			}
		}
	});
	// Stop autoplay on user interaction
	swiper.on('touchStart', function() {
		swiper.autoplay.stop();
	});
	return swiper;
};

const createSlider = (sliderEl) => {
	let slider;

	if (sliderEl.dataset.type === 'textbox') {
		slider = createTextboxSlider(sliderEl);
	}
	else {
		slider = createCommonSlider(sliderEl);
	}

	return slider;
};

export const initSliders = () => {
	const swiperContainers = document.querySelectorAll(SLIDER_SELECTOR);
	if (swiperContainers.length === 0) return;

	swiperContainers.forEach((sliderEl) => {
		try {
			createSlider(sliderEl);
		}
		catch (error) {
			console.error('Slider init failed', sliderEl, error);
		}
	});
};
